import { styled } from 'linaria/react';
import { FunctionalComponent, h } from 'preact';
import { version } from '../../../../package.json';

import { Title, Text } from 'ui/typography';
import { FallbackLayout } from 'features/fallback/ui/fallback-layout';

export type ErrorLayoutProps = {
	title: string;
	description: string;
}

export const ErrorLayout: FunctionalComponent<ErrorLayoutProps> = (props) => {
	const { title, description, children } = props;

	return (
		<FallbackLayout>
			<Title
				style={{
					marginTop: 32,
					textAlign: 'center',
				}}
			>
				{title}
			</Title>
			<IconContainer>
				<img src={`https://cdn.hive.id/verify-js/${version}/images/warning.svg`} alt=""/>
			</IconContainer>
			{typeof description === 'string' ? (
				<Text
					style={{
						marginLeft: 32,
						marginRight: 32,
						textAlign: 'center',
					}}
					dangerouslySetInnerHTML={{
						__html: description,
					}}
				/>
			) : (
				<Text
					style={{
						marginLeft: 32,
						marginRight: 32,
						textAlign: 'center',
					}}
				>
					{description}
				</Text>
			)}
			{children}
		</FallbackLayout>
	);
};

const IconContainer = styled('div')`
	margin: 48px auto 32px;
	
	img {
		min-height: 80px;
	}
`;
